"use client";

import { createContext, useContext, useEffect, useState } from "react";

import type { DomainHooksRegistryInterface } from "~/context/domain-hooks-context/domain-hooks-registry.interface";

const DomainHooksContext = createContext<DomainHooksRegistryInterface | null>(
  null,
);

export function DomainHooksProvider({
  registry,
  children,
}: {
  registry: DomainHooksRegistryInterface;
  children: React.ReactNode;
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <DomainHooksContext.Provider value={registry}>
      {children}
    </DomainHooksContext.Provider>
  );
}

export function useDomainHooks() {
  const context = useContext(DomainHooksContext);
  if (!context) {
    throw new Error("useDomainHooks must be used within a DomainHooksProvider");
  }
  return context;
}
